var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkNarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "180.000000pt",
    height: "125.000000pt",
    viewBox: "0 0 180.000000 125.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,125.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1690 1229 c-19 -12 -265 -251 -547 -532 l-512 -510 -246 241 c-136 132 -261 248 -279 257 -43 23 -80 14 -96 -24 -9 -23 -9 -34 1 -53 19 -36 237 -263 422 -438 136 -130 173 -160 196 -160 24 0 112 83 584 552 305 304 562 567 571 585 20 40 8 79 -29 93 -32 12 -24 14 -65 -11z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkNarrow);
export default __webpack_public_path__ + "static/media/checkmark-narrow.78ac1de5b0cab57fe968c84f16598f38.svg";
export { ForwardRef as ReactComponent };